import React from 'react';
import { Link } from 'react-router-dom';
import HtmlToReact from 'html-to-react';
import ContentImage from './contentImage';

const HtmlToReactParser = HtmlToReact.Parser;

const removeRelativePathFromUrl = url => url.replace(/^.+\.\//, '');

const normalizeKey = key => key && decodeURIComponent(removeRelativePathFromUrl(key));

const getContentKey = (contents, href) => {
  const key = normalizeKey(href);

  const contentObjectKey = contents.find(content => {
    return content.includes(key);
  });

  return contentObjectKey;
};

const getPageRouteByKey = key => {
  return `/user-guide/${key}`;
};

export const parseHtmlToReact = (contents, stringHtml) => {
  const isValidNode = () => true;
  const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
  const processingInstructions = [
    {
      // <html>, <head> and <body> tag processing (change those tags to divs)
      shouldProcessNode: node => {
        return node.type === 'tag' && (node.name === 'html' || node.name === 'head' || node.name === 'body');
      },
      processNode: (node, children, index) => React.createElement('div', { key: index }, children),
    },
    {
      // <details> tag processing (close as default)
      shouldProcessNode: node => node.type === 'tag' && node.name === 'details',
      processNode: (node, children, index) => React.createElement('details', { key: index, open: false }, children),
    },
    {
      // Custom external <a> processing
      shouldProcessNode: node => {
        return (
          node.type === 'tag' &&
          node.name &&
          node.name === 'a' &&
          node.attribs.href.includes('http') &&
          node.attribs.href.includes('https')
        );
      },
      processNode: (node, children) => {
        return (
          <a href={node.attribs.href} target="_blank" rel="noreferrer">
            {children}
          </a>
        );
      },
    },
    {
      // Custom internal <a> processing
      shouldProcessNode: node => {
        return (
          node.type === 'tag' &&
          node.name &&
          node.name === 'a' &&
          !node.attribs.href.includes('http') &&
          !node.attribs.href.includes('https')
        );
      },
      processNode: (node, children, index) => {
        const key = getContentKey(contents, node.attribs.href);

        /* Important to use Link component, so we can have our internal routing from react-router-dom
           Also important to set fresh `key` param, so we can update component loading on route change */
        return (
          <Link key={index} to={getPageRouteByKey(key)} data-cy="user_guide-link">
            {children}
          </Link>
        );
      },
    },
    {
      // Custom <img> processing
      shouldProcessNode: node => {
        return node.type === 'tag' && node.name === 'img' && !node.attribs.src.includes('https');
      },
      processNode: (node, children, index) => {
        const key = getContentKey(contents, node.attribs.src);

        return React.createElement(ContentImage, { key: index, contentKey: key });
      },
    },
    {
      // Anything else
      shouldProcessNode: () => true,
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ];
  const htmlToReactParser = new HtmlToReactParser();
  const reactElement = htmlToReactParser.parseWithInstructions(stringHtml, isValidNode, processingInstructions);

  return reactElement;
};

export const getHomePageGuideKey = (S3FolderName, contents) => {
  // First .html file in specific directory in AWS S3
  const key = contents.find(content => {
    return content.includes(`${S3FolderName}/`) && content.includes('.html');
  });

  return key;
};
